import { PaginatedListPageSkeleton } from '../../components/paginated-list/PaginatedListSkeleton';
import { RoutineCardSkeleton } from '../../components/routine-card/RoutineCardSkeleton';

export const RoutineListPageSkeleton: React.FC = () => {
  return <PaginatedListPageSkeleton ItemSkeleton={<RoutineCardSkeleton />} />;
};
